module.exports = __webpack_public_path__ + "img/IMG_6333.eeeca43c.jpg";